<template>
<p class="control has-icons-right">
<input class="input is-rounded is-large" :class="{'h3rem' : resultSearch}" @input="$emit('input', $event.target.value)" type="text" placeholder="Enter Your Postcode" :value="search_value">
<!-- <input class="input is-rounded is-hidden-desktop is-large"  @input="$emit('input', $event.target.value)" type="text" placeholder="Enter Your Postcode" :value="search_value"> -->
<span class="icon is-right h100">
      <i class="fas fa-search"></i>
</span>
</p>
</template>

<script>
export default {
    data() {
        return {
            Search: "",
        }
    },
    methods: {
    },
    props: {
        size: {
            type: String,
            default: "is-medium"
        },
        search_value: {
            type: String,
        },
        resultSearch: {
            type: Boolean,
            default: false,
        }

    }
}
</script>

<style scoped>

@media (max-width: 768px) {
    .icon {
        font-size: auto !important;
    }
}

.h3rem{
    height: 3rem;
}

.h100 {
    height: 100% !important;
}

.input {
    box-shadow: 0 5px 10px 0 rgba(0,0,0,0.2)
}

</style>
